// src/components/ModalShell.js
//
// Generic modal chrome — overlay, panel, close button. Extracted out of
// SignInModal.js so any modal (SignInModal, and the advisor-connect modal
// now built into ResultCTA.js) shares one overlay/close-button
// implementation instead of each modal re-implementing the same three
// elements. This owns only the shell; callers own all content.

import React from 'react'

export default function ModalShell({ onClose, children }) {
  return (
    <div className="signin-modal-overlay" onClick={onClose}>
      <div className="signin-modal" onClick={e => e.stopPropagation()}>
        <button className="signin-modal-close" onClick={onClose}>✕</button>
        {children}
      </div>
    </div>
  )
}
